import React, { useState } from "react";
import {
  Modal,
  Button,
  Text,
  VisuallyHidden,
} from "@telegram-apps/telegram-ui";
import { DialogDescription, DialogTitle } from "@radix-ui/react-dialog";
import { useI18n } from "../../utils/i18n/I18nProvider";
import "./Onboarding.css";

interface OnboardingProps {
  isOpen: boolean;
  onClose: () => void;
}

const ONBOARDING_SCREENS = [
  {
    titleKey: "onboarding.earn.title",
    textKey: "onboarding.earn.text",
    image: "/assets/img/onboarding/earn-mana.avif",
    fullWidth: true,
  },
  {
    titleKey: "onboarding.getMana1.title",
    textKey: "onboarding.getMana1.text",
    image: "/assets/img/onboarding/complete-levels.avif",
  },
  {
    titleKey: "onboarding.getMana2.title",
    textKey: "onboarding.getMana2.text",
    image: "/assets/img/onboarding/magic-books.avif",
    fullWidth: true,
  },
  {
    titleKey: "onboarding.token.title",
    textKey: "onboarding.token.text",
    image: "/assets/img/onboarding/evl-token.avif",
  },
];

export function Onboarding({ isOpen, onClose }: OnboardingProps) {
  const { t } = useI18n();
  const [currentIndex, setCurrentIndex] = useState(0);

  const currentScreen = ONBOARDING_SCREENS[currentIndex];
  const isLastScreen = currentIndex === ONBOARDING_SCREENS.length - 1;

  const handleNext = () => {
    if (isLastScreen) {
      localStorage.setItem("onboarding_shown_v2", "true");
      onClose();
    } else {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleClose = () => {
    setCurrentIndex(0);
    onClose();
  };

  if (!isOpen || !currentScreen) return null;

  return (
    <div className="onboarding-overlay">
      <div className="onboarding-content">
        <h1 className="onboarding-title">{t(currentScreen.titleKey)}</h1>

        <Text className="onboarding-text">{t(currentScreen.textKey)}</Text>

        {currentScreen.image && (
          <div
            className={`onboarding-illustration ${
              currentScreen.fullWidth ? "full-width" : ""
            }`}
          >
            <img
              src={currentScreen.image}
              alt={t(currentScreen.titleKey)}
              className="onboarding-image"
            />
          </div>
        )}

        <Button size="l" onClick={handleNext} className="onboarding-button">
          {isLastScreen ? t("onboarding.letsPlay") : t("common.next")}
        </Button>

        <div className="onboarding-progress">
          {ONBOARDING_SCREENS.map((_, index) => (
            <div
              key={index}
              className={`onboarding-dot ${
                index === currentIndex ? "active" : ""
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
